/**
 * @deprecated This hook is used for context-free components that are used with the legacy Lightning client-side app,
 * but shouldn't be used for components that live inside of a full React page that uses the {@see ApplicationContext}
 */
export const useUserInfo = () => ({
    dyslexic: window.OverDrive?.dyslexic ?? false,
    locale: window.OverDrive?._locale ?? 'en',
});
